import DAO from './DAO.js';
import projectsService from '../services/projectsService';
import dataModel from '../models/DataModel';
import OfflineQueue from './queue/OfflineQueue.js';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';

export default class CustomProjectSettingsDAO extends DAO {

  constructor(store) {
    super(store, 'custom_project_setting');
    this.OfflineQueue = OfflineQueue;

    this.unsetCustomProjectSetting = this.unsetCustomProjectSetting.bind(this);
    this.clearCustomProjectSettings = this.clearCustomProjectSettings.bind(this);
  }

  unsetCustomProjectSetting(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearCustomProjectSettings() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_custom_project_settings, options.toIgnore.customProjectSettings, this.unsetCustomProjectSetting, this.clearCustomProjectSettings, options);
  }

  getCustomProjectSetting(id, options) {

    return this._getItem(id,
      projectsService.getCustomProjectSetting.bind(this, id),
      options);
  }

  async addCustomSetting(setting, project) {
    return projectsService.createCustomProjectSetting(setting).then(response => {
      if (response.error) {
        dataModel.displayHTTPError('Creating a custom project setting', response.error);
      }
      else {
        return dataModel.projectsDAO.getProject(project.id, { recordDescriptor: { project: { custom_project_settings: {} } } });
      }
    });
  }

  async updateCustomSetting(setting, project) {
    return projectsService.updateCustomProjectSetting(setting).then(response => {
      if (response.error) {
        dataModel.displayHTTPError('Updating a custom project setting', response.error);
      }
      else {
        return dataModel.projectsDAO.getProject(project.id, { recordDescriptor: { project: { custom_project_settings: {} } } });
      }
    });
  }

  deleteCustomSetting(setting, project) {
    this.markPending(project);
    return projectsService.deleteCustomProjectSetting(setting).then(response => {
      if (response.error) {
        dataModel.displayHTTPError('Deleting a custom project setting', response.error);
      }
      else {
        return dataModel.projectsDAO.getProject(project.id, { recordDescriptor: { project: { custom_project_settings: {} } } });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/dao/CustomProjectSettingsDAO.js